/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as EstimationIndexRouteImport } from './routes/estimation/index'
import { Route as AiAdvisoryIndexRouteImport } from './routes/ai-advisory/index'
import { Route as AdministrationIndexRouteImport } from './routes/administration/index'
import { Route as EstimationNewIndexRouteImport } from './routes/estimation/new/index'
import { Route as EstimationVersionsProjectIdIndexRouteImport } from './routes/estimation-versions/$projectId/index'
import { Route as AdministrationExportSettingsIndexRouteImport } from './routes/administration/export-settings/index'
import { Route as AdministrationAiWizardIndexRouteImport } from './routes/administration/ai-wizard/index'
import { Route as EstimationNewMetadataIndexRouteImport } from './routes/estimation/new/metadata/index'
import { Route as EstimationNewBasicsIndexRouteImport } from './routes/estimation/new/basics/index'
import { Route as EstimationDetailEstimationIdIndexRouteImport } from './routes/estimation/detail/$estimationId/index'
import { Route as AdministrationAiWizardTenantContextIndexRouteImport } from './routes/administration/ai-wizard/tenant-context/index'
import { Route as EstimationDetailEstimationIdTabIdRouteImport } from './routes/estimation/detail/$estimationId/$tabId'

const IndexLazyRouteImport = createFileRoute('/')()
const NotificationsIndexLazyRouteImport = createFileRoute('/notifications/')()
const EstimationsIndexLazyRouteImport = createFileRoute('/estimations/')()
const AdministrationWorkflowIndexLazyRouteImport = createFileRoute(
  '/administration/workflow/',
)()
const AdministrationUsersIndexLazyRouteImport = createFileRoute(
  '/administration/users/',
)()
const AdministrationUsageAnalyticsIndexLazyRouteImport = createFileRoute(
  '/administration/usage-analytics/',
)()
const AdministrationTipsNewsIndexLazyRouteImport = createFileRoute(
  '/administration/tips-news/',
)()
const AdministrationTenantSettingsIndexLazyRouteImport = createFileRoute(
  '/administration/tenant-settings/',
)()
const AdministrationProjectTypesIndexLazyRouteImport = createFileRoute(
  '/administration/project-types/',
)()
const AdministrationNotificationsIndexLazyRouteImport = createFileRoute(
  '/administration/notifications/',
)()
const AdministrationNotificationTemplatesIndexLazyRouteImport = createFileRoute(
  '/administration/notification-templates/',
)()
const AdministrationNotificationSettingsIndexLazyRouteImport = createFileRoute(
  '/administration/notification-settings/',
)()
const AdministrationIndividualisationIndexLazyRouteImport = createFileRoute(
  '/administration/individualisation/',
)()
const AdministrationEstimationModelsIndexLazyRouteImport = createFileRoute(
  '/administration/estimation-models/',
)()
const AdministrationEstimationMethodologiesIndexLazyRouteImport =
  createFileRoute('/administration/estimation-methodologies/')()
const EstimationNewReviewLazyRouteImport = createFileRoute(
  '/estimation/new/review',
)()
const EstimationNewProjectPhasesLazyRouteImport = createFileRoute(
  '/estimation/new/project-phases',
)()
const EstimationNewChooseModeLazyRouteImport = createFileRoute(
  '/estimation/new/choose-mode',
)()
const EstimationEstimationIdContinueWizardLazyRouteImport = createFileRoute(
  '/estimation/$estimationId/continue-wizard',
)()
const EstimationNewResourcesIndexLazyRouteImport = createFileRoute(
  '/estimation/new/resources/',
)()
const EstimationNewEstimatingIndexLazyRouteImport = createFileRoute(
  '/estimation/new/estimating/',
)()
const EstimationNewCostsIndexLazyRouteImport = createFileRoute(
  '/estimation/new/costs/',
)()
const EstimationNewChooseModeIndexLazyRouteImport = createFileRoute(
  '/estimation/new/choose-mode/',
)()
const AdministrationEstimationModelsIdIndexLazyRouteImport = createFileRoute(
  '/administration/estimation-models/$id/',
)()
const EstimationNewResourcesSummaryLazyRouteImport = createFileRoute(
  '/estimation/new/resources/summary',
)()
const EstimationNewMetadataOptionalLazyRouteImport = createFileRoute(
  '/estimation/new/metadata/optional',
)()
const EstimationNewMetadataMandatoryLazyRouteImport = createFileRoute(
  '/estimation/new/metadata/mandatory',
)()
const EstimationNewFromAdvisoryConversationIdLazyRouteImport = createFileRoute(
  '/estimation/new/from-advisory/$conversationId',
)()
const EstimationNewEstimatingSummaryLazyRouteImport = createFileRoute(
  '/estimation/new/estimating/summary',
)()
const EstimationNewCostsSummaryLazyRouteImport = createFileRoute(
  '/estimation/new/costs/summary',
)()
const EstimationNewBasicsProjectIndexLazyRouteImport = createFileRoute(
  '/estimation/new/basics/project/',
)()
const EstimationNewBasicsProjectTypeIndexLazyRouteImport = createFileRoute(
  '/estimation/new/basics/project-type/',
)()
const EstimationNewBasicsMethodologyIndexLazyRouteImport = createFileRoute(
  '/estimation/new/basics/methodology/',
)()
const EstimationNewResourcesPhasePhaseIdLazyRouteImport = createFileRoute(
  '/estimation/new/resources/phase/$phaseId',
)()
const EstimationNewEstimatingPhasePhaseIdLazyRouteImport = createFileRoute(
  '/estimation/new/estimating/phase/$phaseId',
)()

const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const NotificationsIndexLazyRoute = NotificationsIndexLazyRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/notifications/index.lazy').then((d) => d.Route),
)
const EstimationsIndexLazyRoute = EstimationsIndexLazyRouteImport.update({
  id: '/estimations/',
  path: '/estimations/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/estimations/index.lazy').then((d) => d.Route),
)
const EstimationIndexRoute = EstimationIndexRouteImport.update({
  id: '/estimation/',
  path: '/estimation/',
  getParentRoute: () => rootRouteImport,
} as any)
const AiAdvisoryIndexRoute = AiAdvisoryIndexRouteImport.update({
  id: '/ai-advisory/',
  path: '/ai-advisory/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/ai-advisory/index.lazy').then((d) => d.Route),
)
const AdministrationIndexRoute = AdministrationIndexRouteImport.update({
  id: '/administration/',
  path: '/administration/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationWorkflowIndexLazyRoute =
  AdministrationWorkflowIndexLazyRouteImport.update({
    id: '/administration/workflow/',
    path: '/administration/workflow/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/workflow/index.lazy').then((d) => d.Route),
  )
const AdministrationUsersIndexLazyRoute =
  AdministrationUsersIndexLazyRouteImport.update({
    id: '/administration/users/',
    path: '/administration/users/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/users/index.lazy').then((d) => d.Route),
  )
const AdministrationUsageAnalyticsIndexLazyRoute =
  AdministrationUsageAnalyticsIndexLazyRouteImport.update({
    id: '/administration/usage-analytics/',
    path: '/administration/usage-analytics/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/usage-analytics/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AdministrationTipsNewsIndexLazyRoute =
  AdministrationTipsNewsIndexLazyRouteImport.update({
    id: '/administration/tips-news/',
    path: '/administration/tips-news/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/tips-news/index.lazy').then((d) => d.Route),
  )
const AdministrationTenantSettingsIndexLazyRoute =
  AdministrationTenantSettingsIndexLazyRouteImport.update({
    id: '/administration/tenant-settings/',
    path: '/administration/tenant-settings/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/tenant-settings/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AdministrationProjectTypesIndexLazyRoute =
  AdministrationProjectTypesIndexLazyRouteImport.update({
    id: '/administration/project-types/',
    path: '/administration/project-types/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/project-types/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AdministrationNotificationsIndexLazyRoute =
  AdministrationNotificationsIndexLazyRouteImport.update({
    id: '/administration/notifications/',
    path: '/administration/notifications/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/notifications/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AdministrationNotificationTemplatesIndexLazyRoute =
  AdministrationNotificationTemplatesIndexLazyRouteImport.update({
    id: '/administration/notification-templates/',
    path: '/administration/notification-templates/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/notification-templates/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AdministrationNotificationSettingsIndexLazyRoute =
  AdministrationNotificationSettingsIndexLazyRouteImport.update({
    id: '/administration/notification-settings/',
    path: '/administration/notification-settings/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/notification-settings/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AdministrationIndividualisationIndexLazyRoute =
  AdministrationIndividualisationIndexLazyRouteImport.update({
    id: '/administration/individualisation/',
    path: '/administration/individualisation/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/individualisation/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AdministrationEstimationModelsIndexLazyRoute =
  AdministrationEstimationModelsIndexLazyRouteImport.update({
    id: '/administration/estimation-models/',
    path: '/administration/estimation-models/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/estimation-models/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AdministrationEstimationMethodologiesIndexLazyRoute =
  AdministrationEstimationMethodologiesIndexLazyRouteImport.update({
    id: '/administration/estimation-methodologies/',
    path: '/administration/estimation-methodologies/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/estimation-methodologies/index.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewIndexRoute = EstimationNewIndexRouteImport.update({
  id: '/estimation/new/',
  path: '/estimation/new/',
  getParentRoute: () => rootRouteImport,
} as any)
const EstimationVersionsProjectIdIndexRoute =
  EstimationVersionsProjectIdIndexRouteImport.update({
    id: '/estimation-versions/$projectId/',
    path: '/estimation-versions/$projectId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationExportSettingsIndexRoute =
  AdministrationExportSettingsIndexRouteImport.update({
    id: '/administration/export-settings/',
    path: '/administration/export-settings/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationAiWizardIndexRoute =
  AdministrationAiWizardIndexRouteImport.update({
    id: '/administration/ai-wizard/',
    path: '/administration/ai-wizard/',
    getParentRoute: () => rootRouteImport,
  } as any)
const EstimationNewReviewLazyRoute = EstimationNewReviewLazyRouteImport.update({
  id: '/estimation/new/review',
  path: '/estimation/new/review',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/estimation/new/review.lazy').then((d) => d.Route),
)
const EstimationNewProjectPhasesLazyRoute =
  EstimationNewProjectPhasesLazyRouteImport.update({
    id: '/estimation/new/project-phases',
    path: '/estimation/new/project-phases',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/project-phases.lazy').then((d) => d.Route),
  )
const EstimationNewChooseModeLazyRoute =
  EstimationNewChooseModeLazyRouteImport.update({
    id: '/estimation/new/choose-mode',
    path: '/estimation/new/choose-mode',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/choose-mode.lazy').then((d) => d.Route),
  )
const EstimationEstimationIdContinueWizardLazyRoute =
  EstimationEstimationIdContinueWizardLazyRouteImport.update({
    id: '/estimation/$estimationId/continue-wizard',
    path: '/estimation/$estimationId/continue-wizard',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/$estimationId/continue-wizard.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewResourcesIndexLazyRoute =
  EstimationNewResourcesIndexLazyRouteImport.update({
    id: '/estimation/new/resources/',
    path: '/estimation/new/resources/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/resources/index.lazy').then((d) => d.Route),
  )
const EstimationNewEstimatingIndexLazyRoute =
  EstimationNewEstimatingIndexLazyRouteImport.update({
    id: '/estimation/new/estimating/',
    path: '/estimation/new/estimating/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/estimating/index.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewCostsIndexLazyRoute =
  EstimationNewCostsIndexLazyRouteImport.update({
    id: '/estimation/new/costs/',
    path: '/estimation/new/costs/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/costs/index.lazy').then((d) => d.Route),
  )
const EstimationNewChooseModeIndexLazyRoute =
  EstimationNewChooseModeIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => EstimationNewChooseModeLazyRoute,
  } as any).lazy(() =>
    import('./routes/estimation/new/choose-mode/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AdministrationEstimationModelsIdIndexLazyRoute =
  AdministrationEstimationModelsIdIndexLazyRouteImport.update({
    id: '/administration/estimation-models/$id/',
    path: '/administration/estimation-models/$id/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/administration/estimation-models/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewMetadataIndexRoute =
  EstimationNewMetadataIndexRouteImport.update({
    id: '/estimation/new/metadata/',
    path: '/estimation/new/metadata/',
    getParentRoute: () => rootRouteImport,
  } as any)
const EstimationNewBasicsIndexRoute =
  EstimationNewBasicsIndexRouteImport.update({
    id: '/estimation/new/basics/',
    path: '/estimation/new/basics/',
    getParentRoute: () => rootRouteImport,
  } as any)
const EstimationDetailEstimationIdIndexRoute =
  EstimationDetailEstimationIdIndexRouteImport.update({
    id: '/estimation/detail/$estimationId/',
    path: '/estimation/detail/$estimationId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationAiWizardTenantContextIndexRoute =
  AdministrationAiWizardTenantContextIndexRouteImport.update({
    id: '/administration/ai-wizard/tenant-context/',
    path: '/administration/ai-wizard/tenant-context/',
    getParentRoute: () => rootRouteImport,
  } as any)
const EstimationNewResourcesSummaryLazyRoute =
  EstimationNewResourcesSummaryLazyRouteImport.update({
    id: '/estimation/new/resources/summary',
    path: '/estimation/new/resources/summary',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/resources/summary.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewMetadataOptionalLazyRoute =
  EstimationNewMetadataOptionalLazyRouteImport.update({
    id: '/estimation/new/metadata/optional',
    path: '/estimation/new/metadata/optional',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/metadata/optional.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewMetadataMandatoryLazyRoute =
  EstimationNewMetadataMandatoryLazyRouteImport.update({
    id: '/estimation/new/metadata/mandatory',
    path: '/estimation/new/metadata/mandatory',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/metadata/mandatory.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewFromAdvisoryConversationIdLazyRoute =
  EstimationNewFromAdvisoryConversationIdLazyRouteImport.update({
    id: '/estimation/new/from-advisory/$conversationId',
    path: '/estimation/new/from-advisory/$conversationId',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/from-advisory/$conversationId.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewEstimatingSummaryLazyRoute =
  EstimationNewEstimatingSummaryLazyRouteImport.update({
    id: '/estimation/new/estimating/summary',
    path: '/estimation/new/estimating/summary',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/estimating/summary.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewCostsSummaryLazyRoute =
  EstimationNewCostsSummaryLazyRouteImport.update({
    id: '/estimation/new/costs/summary',
    path: '/estimation/new/costs/summary',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/costs/summary.lazy').then((d) => d.Route),
  )
const EstimationDetailEstimationIdTabIdRoute =
  EstimationDetailEstimationIdTabIdRouteImport.update({
    id: '/estimation/detail/$estimationId/$tabId',
    path: '/estimation/detail/$estimationId/$tabId',
    getParentRoute: () => rootRouteImport,
  } as any)
const EstimationNewBasicsProjectIndexLazyRoute =
  EstimationNewBasicsProjectIndexLazyRouteImport.update({
    id: '/estimation/new/basics/project/',
    path: '/estimation/new/basics/project/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/basics/project/index.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewBasicsProjectTypeIndexLazyRoute =
  EstimationNewBasicsProjectTypeIndexLazyRouteImport.update({
    id: '/estimation/new/basics/project-type/',
    path: '/estimation/new/basics/project-type/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/basics/project-type/index.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewBasicsMethodologyIndexLazyRoute =
  EstimationNewBasicsMethodologyIndexLazyRouteImport.update({
    id: '/estimation/new/basics/methodology/',
    path: '/estimation/new/basics/methodology/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/basics/methodology/index.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewResourcesPhasePhaseIdLazyRoute =
  EstimationNewResourcesPhasePhaseIdLazyRouteImport.update({
    id: '/estimation/new/resources/phase/$phaseId',
    path: '/estimation/new/resources/phase/$phaseId',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/resources/phase/$phaseId.lazy').then(
      (d) => d.Route,
    ),
  )
const EstimationNewEstimatingPhasePhaseIdLazyRoute =
  EstimationNewEstimatingPhasePhaseIdLazyRouteImport.update({
    id: '/estimation/new/estimating/phase/$phaseId',
    path: '/estimation/new/estimating/phase/$phaseId',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/estimation/new/estimating/phase/$phaseId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/administration/': typeof AdministrationIndexRoute
  '/ai-advisory/': typeof AiAdvisoryIndexRoute
  '/estimation/': typeof EstimationIndexRoute
  '/estimations/': typeof EstimationsIndexLazyRoute
  '/notifications/': typeof NotificationsIndexLazyRoute
  '/estimation/$estimationId/continue-wizard': typeof EstimationEstimationIdContinueWizardLazyRoute
  '/estimation/new/choose-mode': typeof EstimationNewChooseModeLazyRouteWithChildren
  '/estimation/new/project-phases': typeof EstimationNewProjectPhasesLazyRoute
  '/estimation/new/review': typeof EstimationNewReviewLazyRoute
  '/administration/ai-wizard/': typeof AdministrationAiWizardIndexRoute
  '/administration/export-settings/': typeof AdministrationExportSettingsIndexRoute
  '/estimation-versions/$projectId/': typeof EstimationVersionsProjectIdIndexRoute
  '/estimation/new/': typeof EstimationNewIndexRoute
  '/administration/estimation-methodologies/': typeof AdministrationEstimationMethodologiesIndexLazyRoute
  '/administration/estimation-models/': typeof AdministrationEstimationModelsIndexLazyRoute
  '/administration/individualisation/': typeof AdministrationIndividualisationIndexLazyRoute
  '/administration/notification-settings/': typeof AdministrationNotificationSettingsIndexLazyRoute
  '/administration/notification-templates/': typeof AdministrationNotificationTemplatesIndexLazyRoute
  '/administration/notifications/': typeof AdministrationNotificationsIndexLazyRoute
  '/administration/project-types/': typeof AdministrationProjectTypesIndexLazyRoute
  '/administration/tenant-settings/': typeof AdministrationTenantSettingsIndexLazyRoute
  '/administration/tips-news/': typeof AdministrationTipsNewsIndexLazyRoute
  '/administration/usage-analytics/': typeof AdministrationUsageAnalyticsIndexLazyRoute
  '/administration/users/': typeof AdministrationUsersIndexLazyRoute
  '/administration/workflow/': typeof AdministrationWorkflowIndexLazyRoute
  '/estimation/detail/$estimationId/$tabId': typeof EstimationDetailEstimationIdTabIdRoute
  '/estimation/new/costs/summary': typeof EstimationNewCostsSummaryLazyRoute
  '/estimation/new/estimating/summary': typeof EstimationNewEstimatingSummaryLazyRoute
  '/estimation/new/from-advisory/$conversationId': typeof EstimationNewFromAdvisoryConversationIdLazyRoute
  '/estimation/new/metadata/mandatory': typeof EstimationNewMetadataMandatoryLazyRoute
  '/estimation/new/metadata/optional': typeof EstimationNewMetadataOptionalLazyRoute
  '/estimation/new/resources/summary': typeof EstimationNewResourcesSummaryLazyRoute
  '/administration/ai-wizard/tenant-context/': typeof AdministrationAiWizardTenantContextIndexRoute
  '/estimation/detail/$estimationId/': typeof EstimationDetailEstimationIdIndexRoute
  '/estimation/new/basics/': typeof EstimationNewBasicsIndexRoute
  '/estimation/new/metadata/': typeof EstimationNewMetadataIndexRoute
  '/administration/estimation-models/$id/': typeof AdministrationEstimationModelsIdIndexLazyRoute
  '/estimation/new/choose-mode/': typeof EstimationNewChooseModeIndexLazyRoute
  '/estimation/new/costs/': typeof EstimationNewCostsIndexLazyRoute
  '/estimation/new/estimating/': typeof EstimationNewEstimatingIndexLazyRoute
  '/estimation/new/resources/': typeof EstimationNewResourcesIndexLazyRoute
  '/estimation/new/estimating/phase/$phaseId': typeof EstimationNewEstimatingPhasePhaseIdLazyRoute
  '/estimation/new/resources/phase/$phaseId': typeof EstimationNewResourcesPhasePhaseIdLazyRoute
  '/estimation/new/basics/methodology/': typeof EstimationNewBasicsMethodologyIndexLazyRoute
  '/estimation/new/basics/project-type/': typeof EstimationNewBasicsProjectTypeIndexLazyRoute
  '/estimation/new/basics/project/': typeof EstimationNewBasicsProjectIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/administration': typeof AdministrationIndexRoute
  '/ai-advisory': typeof AiAdvisoryIndexRoute
  '/estimation': typeof EstimationIndexRoute
  '/estimations': typeof EstimationsIndexLazyRoute
  '/notifications': typeof NotificationsIndexLazyRoute
  '/estimation/$estimationId/continue-wizard': typeof EstimationEstimationIdContinueWizardLazyRoute
  '/estimation/new/project-phases': typeof EstimationNewProjectPhasesLazyRoute
  '/estimation/new/review': typeof EstimationNewReviewLazyRoute
  '/administration/ai-wizard': typeof AdministrationAiWizardIndexRoute
  '/administration/export-settings': typeof AdministrationExportSettingsIndexRoute
  '/estimation-versions/$projectId': typeof EstimationVersionsProjectIdIndexRoute
  '/estimation/new': typeof EstimationNewIndexRoute
  '/administration/estimation-methodologies': typeof AdministrationEstimationMethodologiesIndexLazyRoute
  '/administration/estimation-models': typeof AdministrationEstimationModelsIndexLazyRoute
  '/administration/individualisation': typeof AdministrationIndividualisationIndexLazyRoute
  '/administration/notification-settings': typeof AdministrationNotificationSettingsIndexLazyRoute
  '/administration/notification-templates': typeof AdministrationNotificationTemplatesIndexLazyRoute
  '/administration/notifications': typeof AdministrationNotificationsIndexLazyRoute
  '/administration/project-types': typeof AdministrationProjectTypesIndexLazyRoute
  '/administration/tenant-settings': typeof AdministrationTenantSettingsIndexLazyRoute
  '/administration/tips-news': typeof AdministrationTipsNewsIndexLazyRoute
  '/administration/usage-analytics': typeof AdministrationUsageAnalyticsIndexLazyRoute
  '/administration/users': typeof AdministrationUsersIndexLazyRoute
  '/administration/workflow': typeof AdministrationWorkflowIndexLazyRoute
  '/estimation/detail/$estimationId/$tabId': typeof EstimationDetailEstimationIdTabIdRoute
  '/estimation/new/costs/summary': typeof EstimationNewCostsSummaryLazyRoute
  '/estimation/new/estimating/summary': typeof EstimationNewEstimatingSummaryLazyRoute
  '/estimation/new/from-advisory/$conversationId': typeof EstimationNewFromAdvisoryConversationIdLazyRoute
  '/estimation/new/metadata/mandatory': typeof EstimationNewMetadataMandatoryLazyRoute
  '/estimation/new/metadata/optional': typeof EstimationNewMetadataOptionalLazyRoute
  '/estimation/new/resources/summary': typeof EstimationNewResourcesSummaryLazyRoute
  '/administration/ai-wizard/tenant-context': typeof AdministrationAiWizardTenantContextIndexRoute
  '/estimation/detail/$estimationId': typeof EstimationDetailEstimationIdIndexRoute
  '/estimation/new/basics': typeof EstimationNewBasicsIndexRoute
  '/estimation/new/metadata': typeof EstimationNewMetadataIndexRoute
  '/administration/estimation-models/$id': typeof AdministrationEstimationModelsIdIndexLazyRoute
  '/estimation/new/choose-mode': typeof EstimationNewChooseModeIndexLazyRoute
  '/estimation/new/costs': typeof EstimationNewCostsIndexLazyRoute
  '/estimation/new/estimating': typeof EstimationNewEstimatingIndexLazyRoute
  '/estimation/new/resources': typeof EstimationNewResourcesIndexLazyRoute
  '/estimation/new/estimating/phase/$phaseId': typeof EstimationNewEstimatingPhasePhaseIdLazyRoute
  '/estimation/new/resources/phase/$phaseId': typeof EstimationNewResourcesPhasePhaseIdLazyRoute
  '/estimation/new/basics/methodology': typeof EstimationNewBasicsMethodologyIndexLazyRoute
  '/estimation/new/basics/project-type': typeof EstimationNewBasicsProjectTypeIndexLazyRoute
  '/estimation/new/basics/project': typeof EstimationNewBasicsProjectIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/administration/': typeof AdministrationIndexRoute
  '/ai-advisory/': typeof AiAdvisoryIndexRoute
  '/estimation/': typeof EstimationIndexRoute
  '/estimations/': typeof EstimationsIndexLazyRoute
  '/notifications/': typeof NotificationsIndexLazyRoute
  '/estimation/$estimationId/continue-wizard': typeof EstimationEstimationIdContinueWizardLazyRoute
  '/estimation/new/choose-mode': typeof EstimationNewChooseModeLazyRouteWithChildren
  '/estimation/new/project-phases': typeof EstimationNewProjectPhasesLazyRoute
  '/estimation/new/review': typeof EstimationNewReviewLazyRoute
  '/administration/ai-wizard/': typeof AdministrationAiWizardIndexRoute
  '/administration/export-settings/': typeof AdministrationExportSettingsIndexRoute
  '/estimation-versions/$projectId/': typeof EstimationVersionsProjectIdIndexRoute
  '/estimation/new/': typeof EstimationNewIndexRoute
  '/administration/estimation-methodologies/': typeof AdministrationEstimationMethodologiesIndexLazyRoute
  '/administration/estimation-models/': typeof AdministrationEstimationModelsIndexLazyRoute
  '/administration/individualisation/': typeof AdministrationIndividualisationIndexLazyRoute
  '/administration/notification-settings/': typeof AdministrationNotificationSettingsIndexLazyRoute
  '/administration/notification-templates/': typeof AdministrationNotificationTemplatesIndexLazyRoute
  '/administration/notifications/': typeof AdministrationNotificationsIndexLazyRoute
  '/administration/project-types/': typeof AdministrationProjectTypesIndexLazyRoute
  '/administration/tenant-settings/': typeof AdministrationTenantSettingsIndexLazyRoute
  '/administration/tips-news/': typeof AdministrationTipsNewsIndexLazyRoute
  '/administration/usage-analytics/': typeof AdministrationUsageAnalyticsIndexLazyRoute
  '/administration/users/': typeof AdministrationUsersIndexLazyRoute
  '/administration/workflow/': typeof AdministrationWorkflowIndexLazyRoute
  '/estimation/detail/$estimationId/$tabId': typeof EstimationDetailEstimationIdTabIdRoute
  '/estimation/new/costs/summary': typeof EstimationNewCostsSummaryLazyRoute
  '/estimation/new/estimating/summary': typeof EstimationNewEstimatingSummaryLazyRoute
  '/estimation/new/from-advisory/$conversationId': typeof EstimationNewFromAdvisoryConversationIdLazyRoute
  '/estimation/new/metadata/mandatory': typeof EstimationNewMetadataMandatoryLazyRoute
  '/estimation/new/metadata/optional': typeof EstimationNewMetadataOptionalLazyRoute
  '/estimation/new/resources/summary': typeof EstimationNewResourcesSummaryLazyRoute
  '/administration/ai-wizard/tenant-context/': typeof AdministrationAiWizardTenantContextIndexRoute
  '/estimation/detail/$estimationId/': typeof EstimationDetailEstimationIdIndexRoute
  '/estimation/new/basics/': typeof EstimationNewBasicsIndexRoute
  '/estimation/new/metadata/': typeof EstimationNewMetadataIndexRoute
  '/administration/estimation-models/$id/': typeof AdministrationEstimationModelsIdIndexLazyRoute
  '/estimation/new/choose-mode/': typeof EstimationNewChooseModeIndexLazyRoute
  '/estimation/new/costs/': typeof EstimationNewCostsIndexLazyRoute
  '/estimation/new/estimating/': typeof EstimationNewEstimatingIndexLazyRoute
  '/estimation/new/resources/': typeof EstimationNewResourcesIndexLazyRoute
  '/estimation/new/estimating/phase/$phaseId': typeof EstimationNewEstimatingPhasePhaseIdLazyRoute
  '/estimation/new/resources/phase/$phaseId': typeof EstimationNewResourcesPhasePhaseIdLazyRoute
  '/estimation/new/basics/methodology/': typeof EstimationNewBasicsMethodologyIndexLazyRoute
  '/estimation/new/basics/project-type/': typeof EstimationNewBasicsProjectTypeIndexLazyRoute
  '/estimation/new/basics/project/': typeof EstimationNewBasicsProjectIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/administration/'
    | '/ai-advisory/'
    | '/estimation/'
    | '/estimations/'
    | '/notifications/'
    | '/estimation/$estimationId/continue-wizard'
    | '/estimation/new/choose-mode'
    | '/estimation/new/project-phases'
    | '/estimation/new/review'
    | '/administration/ai-wizard/'
    | '/administration/export-settings/'
    | '/estimation-versions/$projectId/'
    | '/estimation/new/'
    | '/administration/estimation-methodologies/'
    | '/administration/estimation-models/'
    | '/administration/individualisation/'
    | '/administration/notification-settings/'
    | '/administration/notification-templates/'
    | '/administration/notifications/'
    | '/administration/project-types/'
    | '/administration/tenant-settings/'
    | '/administration/tips-news/'
    | '/administration/usage-analytics/'
    | '/administration/users/'
    | '/administration/workflow/'
    | '/estimation/detail/$estimationId/$tabId'
    | '/estimation/new/costs/summary'
    | '/estimation/new/estimating/summary'
    | '/estimation/new/from-advisory/$conversationId'
    | '/estimation/new/metadata/mandatory'
    | '/estimation/new/metadata/optional'
    | '/estimation/new/resources/summary'
    | '/administration/ai-wizard/tenant-context/'
    | '/estimation/detail/$estimationId/'
    | '/estimation/new/basics/'
    | '/estimation/new/metadata/'
    | '/administration/estimation-models/$id/'
    | '/estimation/new/choose-mode/'
    | '/estimation/new/costs/'
    | '/estimation/new/estimating/'
    | '/estimation/new/resources/'
    | '/estimation/new/estimating/phase/$phaseId'
    | '/estimation/new/resources/phase/$phaseId'
    | '/estimation/new/basics/methodology/'
    | '/estimation/new/basics/project-type/'
    | '/estimation/new/basics/project/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/administration'
    | '/ai-advisory'
    | '/estimation'
    | '/estimations'
    | '/notifications'
    | '/estimation/$estimationId/continue-wizard'
    | '/estimation/new/project-phases'
    | '/estimation/new/review'
    | '/administration/ai-wizard'
    | '/administration/export-settings'
    | '/estimation-versions/$projectId'
    | '/estimation/new'
    | '/administration/estimation-methodologies'
    | '/administration/estimation-models'
    | '/administration/individualisation'
    | '/administration/notification-settings'
    | '/administration/notification-templates'
    | '/administration/notifications'
    | '/administration/project-types'
    | '/administration/tenant-settings'
    | '/administration/tips-news'
    | '/administration/usage-analytics'
    | '/administration/users'
    | '/administration/workflow'
    | '/estimation/detail/$estimationId/$tabId'
    | '/estimation/new/costs/summary'
    | '/estimation/new/estimating/summary'
    | '/estimation/new/from-advisory/$conversationId'
    | '/estimation/new/metadata/mandatory'
    | '/estimation/new/metadata/optional'
    | '/estimation/new/resources/summary'
    | '/administration/ai-wizard/tenant-context'
    | '/estimation/detail/$estimationId'
    | '/estimation/new/basics'
    | '/estimation/new/metadata'
    | '/administration/estimation-models/$id'
    | '/estimation/new/choose-mode'
    | '/estimation/new/costs'
    | '/estimation/new/estimating'
    | '/estimation/new/resources'
    | '/estimation/new/estimating/phase/$phaseId'
    | '/estimation/new/resources/phase/$phaseId'
    | '/estimation/new/basics/methodology'
    | '/estimation/new/basics/project-type'
    | '/estimation/new/basics/project'
  id:
    | '__root__'
    | '/'
    | '/administration/'
    | '/ai-advisory/'
    | '/estimation/'
    | '/estimations/'
    | '/notifications/'
    | '/estimation/$estimationId/continue-wizard'
    | '/estimation/new/choose-mode'
    | '/estimation/new/project-phases'
    | '/estimation/new/review'
    | '/administration/ai-wizard/'
    | '/administration/export-settings/'
    | '/estimation-versions/$projectId/'
    | '/estimation/new/'
    | '/administration/estimation-methodologies/'
    | '/administration/estimation-models/'
    | '/administration/individualisation/'
    | '/administration/notification-settings/'
    | '/administration/notification-templates/'
    | '/administration/notifications/'
    | '/administration/project-types/'
    | '/administration/tenant-settings/'
    | '/administration/tips-news/'
    | '/administration/usage-analytics/'
    | '/administration/users/'
    | '/administration/workflow/'
    | '/estimation/detail/$estimationId/$tabId'
    | '/estimation/new/costs/summary'
    | '/estimation/new/estimating/summary'
    | '/estimation/new/from-advisory/$conversationId'
    | '/estimation/new/metadata/mandatory'
    | '/estimation/new/metadata/optional'
    | '/estimation/new/resources/summary'
    | '/administration/ai-wizard/tenant-context/'
    | '/estimation/detail/$estimationId/'
    | '/estimation/new/basics/'
    | '/estimation/new/metadata/'
    | '/administration/estimation-models/$id/'
    | '/estimation/new/choose-mode/'
    | '/estimation/new/costs/'
    | '/estimation/new/estimating/'
    | '/estimation/new/resources/'
    | '/estimation/new/estimating/phase/$phaseId'
    | '/estimation/new/resources/phase/$phaseId'
    | '/estimation/new/basics/methodology/'
    | '/estimation/new/basics/project-type/'
    | '/estimation/new/basics/project/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AdministrationIndexRoute: typeof AdministrationIndexRoute
  AiAdvisoryIndexRoute: typeof AiAdvisoryIndexRoute
  EstimationIndexRoute: typeof EstimationIndexRoute
  EstimationsIndexLazyRoute: typeof EstimationsIndexLazyRoute
  NotificationsIndexLazyRoute: typeof NotificationsIndexLazyRoute
  EstimationEstimationIdContinueWizardLazyRoute: typeof EstimationEstimationIdContinueWizardLazyRoute
  EstimationNewChooseModeLazyRoute: typeof EstimationNewChooseModeLazyRouteWithChildren
  EstimationNewProjectPhasesLazyRoute: typeof EstimationNewProjectPhasesLazyRoute
  EstimationNewReviewLazyRoute: typeof EstimationNewReviewLazyRoute
  AdministrationAiWizardIndexRoute: typeof AdministrationAiWizardIndexRoute
  AdministrationExportSettingsIndexRoute: typeof AdministrationExportSettingsIndexRoute
  EstimationVersionsProjectIdIndexRoute: typeof EstimationVersionsProjectIdIndexRoute
  EstimationNewIndexRoute: typeof EstimationNewIndexRoute
  AdministrationEstimationMethodologiesIndexLazyRoute: typeof AdministrationEstimationMethodologiesIndexLazyRoute
  AdministrationEstimationModelsIndexLazyRoute: typeof AdministrationEstimationModelsIndexLazyRoute
  AdministrationIndividualisationIndexLazyRoute: typeof AdministrationIndividualisationIndexLazyRoute
  AdministrationNotificationSettingsIndexLazyRoute: typeof AdministrationNotificationSettingsIndexLazyRoute
  AdministrationNotificationTemplatesIndexLazyRoute: typeof AdministrationNotificationTemplatesIndexLazyRoute
  AdministrationNotificationsIndexLazyRoute: typeof AdministrationNotificationsIndexLazyRoute
  AdministrationProjectTypesIndexLazyRoute: typeof AdministrationProjectTypesIndexLazyRoute
  AdministrationTenantSettingsIndexLazyRoute: typeof AdministrationTenantSettingsIndexLazyRoute
  AdministrationTipsNewsIndexLazyRoute: typeof AdministrationTipsNewsIndexLazyRoute
  AdministrationUsageAnalyticsIndexLazyRoute: typeof AdministrationUsageAnalyticsIndexLazyRoute
  AdministrationUsersIndexLazyRoute: typeof AdministrationUsersIndexLazyRoute
  AdministrationWorkflowIndexLazyRoute: typeof AdministrationWorkflowIndexLazyRoute
  EstimationDetailEstimationIdTabIdRoute: typeof EstimationDetailEstimationIdTabIdRoute
  EstimationNewCostsSummaryLazyRoute: typeof EstimationNewCostsSummaryLazyRoute
  EstimationNewEstimatingSummaryLazyRoute: typeof EstimationNewEstimatingSummaryLazyRoute
  EstimationNewFromAdvisoryConversationIdLazyRoute: typeof EstimationNewFromAdvisoryConversationIdLazyRoute
  EstimationNewMetadataMandatoryLazyRoute: typeof EstimationNewMetadataMandatoryLazyRoute
  EstimationNewMetadataOptionalLazyRoute: typeof EstimationNewMetadataOptionalLazyRoute
  EstimationNewResourcesSummaryLazyRoute: typeof EstimationNewResourcesSummaryLazyRoute
  AdministrationAiWizardTenantContextIndexRoute: typeof AdministrationAiWizardTenantContextIndexRoute
  EstimationDetailEstimationIdIndexRoute: typeof EstimationDetailEstimationIdIndexRoute
  EstimationNewBasicsIndexRoute: typeof EstimationNewBasicsIndexRoute
  EstimationNewMetadataIndexRoute: typeof EstimationNewMetadataIndexRoute
  AdministrationEstimationModelsIdIndexLazyRoute: typeof AdministrationEstimationModelsIdIndexLazyRoute
  EstimationNewCostsIndexLazyRoute: typeof EstimationNewCostsIndexLazyRoute
  EstimationNewEstimatingIndexLazyRoute: typeof EstimationNewEstimatingIndexLazyRoute
  EstimationNewResourcesIndexLazyRoute: typeof EstimationNewResourcesIndexLazyRoute
  EstimationNewEstimatingPhasePhaseIdLazyRoute: typeof EstimationNewEstimatingPhasePhaseIdLazyRoute
  EstimationNewResourcesPhasePhaseIdLazyRoute: typeof EstimationNewResourcesPhasePhaseIdLazyRoute
  EstimationNewBasicsMethodologyIndexLazyRoute: typeof EstimationNewBasicsMethodologyIndexLazyRoute
  EstimationNewBasicsProjectTypeIndexLazyRoute: typeof EstimationNewBasicsProjectTypeIndexLazyRoute
  EstimationNewBasicsProjectIndexLazyRoute: typeof EstimationNewBasicsProjectIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/': {
      id: '/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof NotificationsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimations/': {
      id: '/estimations/'
      path: '/estimations'
      fullPath: '/estimations/'
      preLoaderRoute: typeof EstimationsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/': {
      id: '/estimation/'
      path: '/estimation'
      fullPath: '/estimation/'
      preLoaderRoute: typeof EstimationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-advisory/': {
      id: '/ai-advisory/'
      path: '/ai-advisory'
      fullPath: '/ai-advisory/'
      preLoaderRoute: typeof AiAdvisoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/': {
      id: '/administration/'
      path: '/administration'
      fullPath: '/administration/'
      preLoaderRoute: typeof AdministrationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/workflow/': {
      id: '/administration/workflow/'
      path: '/administration/workflow'
      fullPath: '/administration/workflow/'
      preLoaderRoute: typeof AdministrationWorkflowIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/users/': {
      id: '/administration/users/'
      path: '/administration/users'
      fullPath: '/administration/users/'
      preLoaderRoute: typeof AdministrationUsersIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/usage-analytics/': {
      id: '/administration/usage-analytics/'
      path: '/administration/usage-analytics'
      fullPath: '/administration/usage-analytics/'
      preLoaderRoute: typeof AdministrationUsageAnalyticsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/tips-news/': {
      id: '/administration/tips-news/'
      path: '/administration/tips-news'
      fullPath: '/administration/tips-news/'
      preLoaderRoute: typeof AdministrationTipsNewsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/tenant-settings/': {
      id: '/administration/tenant-settings/'
      path: '/administration/tenant-settings'
      fullPath: '/administration/tenant-settings/'
      preLoaderRoute: typeof AdministrationTenantSettingsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/project-types/': {
      id: '/administration/project-types/'
      path: '/administration/project-types'
      fullPath: '/administration/project-types/'
      preLoaderRoute: typeof AdministrationProjectTypesIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/notifications/': {
      id: '/administration/notifications/'
      path: '/administration/notifications'
      fullPath: '/administration/notifications/'
      preLoaderRoute: typeof AdministrationNotificationsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/notification-templates/': {
      id: '/administration/notification-templates/'
      path: '/administration/notification-templates'
      fullPath: '/administration/notification-templates/'
      preLoaderRoute: typeof AdministrationNotificationTemplatesIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/notification-settings/': {
      id: '/administration/notification-settings/'
      path: '/administration/notification-settings'
      fullPath: '/administration/notification-settings/'
      preLoaderRoute: typeof AdministrationNotificationSettingsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/individualisation/': {
      id: '/administration/individualisation/'
      path: '/administration/individualisation'
      fullPath: '/administration/individualisation/'
      preLoaderRoute: typeof AdministrationIndividualisationIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/estimation-models/': {
      id: '/administration/estimation-models/'
      path: '/administration/estimation-models'
      fullPath: '/administration/estimation-models/'
      preLoaderRoute: typeof AdministrationEstimationModelsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/estimation-methodologies/': {
      id: '/administration/estimation-methodologies/'
      path: '/administration/estimation-methodologies'
      fullPath: '/administration/estimation-methodologies/'
      preLoaderRoute: typeof AdministrationEstimationMethodologiesIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/': {
      id: '/estimation/new/'
      path: '/estimation/new'
      fullPath: '/estimation/new/'
      preLoaderRoute: typeof EstimationNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation-versions/$projectId/': {
      id: '/estimation-versions/$projectId/'
      path: '/estimation-versions/$projectId'
      fullPath: '/estimation-versions/$projectId/'
      preLoaderRoute: typeof EstimationVersionsProjectIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/export-settings/': {
      id: '/administration/export-settings/'
      path: '/administration/export-settings'
      fullPath: '/administration/export-settings/'
      preLoaderRoute: typeof AdministrationExportSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/ai-wizard/': {
      id: '/administration/ai-wizard/'
      path: '/administration/ai-wizard'
      fullPath: '/administration/ai-wizard/'
      preLoaderRoute: typeof AdministrationAiWizardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/review': {
      id: '/estimation/new/review'
      path: '/estimation/new/review'
      fullPath: '/estimation/new/review'
      preLoaderRoute: typeof EstimationNewReviewLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/project-phases': {
      id: '/estimation/new/project-phases'
      path: '/estimation/new/project-phases'
      fullPath: '/estimation/new/project-phases'
      preLoaderRoute: typeof EstimationNewProjectPhasesLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/choose-mode': {
      id: '/estimation/new/choose-mode'
      path: '/estimation/new/choose-mode'
      fullPath: '/estimation/new/choose-mode'
      preLoaderRoute: typeof EstimationNewChooseModeLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/$estimationId/continue-wizard': {
      id: '/estimation/$estimationId/continue-wizard'
      path: '/estimation/$estimationId/continue-wizard'
      fullPath: '/estimation/$estimationId/continue-wizard'
      preLoaderRoute: typeof EstimationEstimationIdContinueWizardLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/resources/': {
      id: '/estimation/new/resources/'
      path: '/estimation/new/resources'
      fullPath: '/estimation/new/resources/'
      preLoaderRoute: typeof EstimationNewResourcesIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/estimating/': {
      id: '/estimation/new/estimating/'
      path: '/estimation/new/estimating'
      fullPath: '/estimation/new/estimating/'
      preLoaderRoute: typeof EstimationNewEstimatingIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/costs/': {
      id: '/estimation/new/costs/'
      path: '/estimation/new/costs'
      fullPath: '/estimation/new/costs/'
      preLoaderRoute: typeof EstimationNewCostsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/choose-mode/': {
      id: '/estimation/new/choose-mode/'
      path: '/'
      fullPath: '/estimation/new/choose-mode/'
      preLoaderRoute: typeof EstimationNewChooseModeIndexLazyRouteImport
      parentRoute: typeof EstimationNewChooseModeLazyRoute
    }
    '/administration/estimation-models/$id/': {
      id: '/administration/estimation-models/$id/'
      path: '/administration/estimation-models/$id'
      fullPath: '/administration/estimation-models/$id/'
      preLoaderRoute: typeof AdministrationEstimationModelsIdIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/metadata/': {
      id: '/estimation/new/metadata/'
      path: '/estimation/new/metadata'
      fullPath: '/estimation/new/metadata/'
      preLoaderRoute: typeof EstimationNewMetadataIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/basics/': {
      id: '/estimation/new/basics/'
      path: '/estimation/new/basics'
      fullPath: '/estimation/new/basics/'
      preLoaderRoute: typeof EstimationNewBasicsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/detail/$estimationId/': {
      id: '/estimation/detail/$estimationId/'
      path: '/estimation/detail/$estimationId'
      fullPath: '/estimation/detail/$estimationId/'
      preLoaderRoute: typeof EstimationDetailEstimationIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/ai-wizard/tenant-context/': {
      id: '/administration/ai-wizard/tenant-context/'
      path: '/administration/ai-wizard/tenant-context'
      fullPath: '/administration/ai-wizard/tenant-context/'
      preLoaderRoute: typeof AdministrationAiWizardTenantContextIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/resources/summary': {
      id: '/estimation/new/resources/summary'
      path: '/estimation/new/resources/summary'
      fullPath: '/estimation/new/resources/summary'
      preLoaderRoute: typeof EstimationNewResourcesSummaryLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/metadata/optional': {
      id: '/estimation/new/metadata/optional'
      path: '/estimation/new/metadata/optional'
      fullPath: '/estimation/new/metadata/optional'
      preLoaderRoute: typeof EstimationNewMetadataOptionalLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/metadata/mandatory': {
      id: '/estimation/new/metadata/mandatory'
      path: '/estimation/new/metadata/mandatory'
      fullPath: '/estimation/new/metadata/mandatory'
      preLoaderRoute: typeof EstimationNewMetadataMandatoryLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/from-advisory/$conversationId': {
      id: '/estimation/new/from-advisory/$conversationId'
      path: '/estimation/new/from-advisory/$conversationId'
      fullPath: '/estimation/new/from-advisory/$conversationId'
      preLoaderRoute: typeof EstimationNewFromAdvisoryConversationIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/estimating/summary': {
      id: '/estimation/new/estimating/summary'
      path: '/estimation/new/estimating/summary'
      fullPath: '/estimation/new/estimating/summary'
      preLoaderRoute: typeof EstimationNewEstimatingSummaryLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/costs/summary': {
      id: '/estimation/new/costs/summary'
      path: '/estimation/new/costs/summary'
      fullPath: '/estimation/new/costs/summary'
      preLoaderRoute: typeof EstimationNewCostsSummaryLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/detail/$estimationId/$tabId': {
      id: '/estimation/detail/$estimationId/$tabId'
      path: '/estimation/detail/$estimationId/$tabId'
      fullPath: '/estimation/detail/$estimationId/$tabId'
      preLoaderRoute: typeof EstimationDetailEstimationIdTabIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/basics/project/': {
      id: '/estimation/new/basics/project/'
      path: '/estimation/new/basics/project'
      fullPath: '/estimation/new/basics/project/'
      preLoaderRoute: typeof EstimationNewBasicsProjectIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/basics/project-type/': {
      id: '/estimation/new/basics/project-type/'
      path: '/estimation/new/basics/project-type'
      fullPath: '/estimation/new/basics/project-type/'
      preLoaderRoute: typeof EstimationNewBasicsProjectTypeIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/basics/methodology/': {
      id: '/estimation/new/basics/methodology/'
      path: '/estimation/new/basics/methodology'
      fullPath: '/estimation/new/basics/methodology/'
      preLoaderRoute: typeof EstimationNewBasicsMethodologyIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/resources/phase/$phaseId': {
      id: '/estimation/new/resources/phase/$phaseId'
      path: '/estimation/new/resources/phase/$phaseId'
      fullPath: '/estimation/new/resources/phase/$phaseId'
      preLoaderRoute: typeof EstimationNewResourcesPhasePhaseIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimation/new/estimating/phase/$phaseId': {
      id: '/estimation/new/estimating/phase/$phaseId'
      path: '/estimation/new/estimating/phase/$phaseId'
      fullPath: '/estimation/new/estimating/phase/$phaseId'
      preLoaderRoute: typeof EstimationNewEstimatingPhasePhaseIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface EstimationNewChooseModeLazyRouteChildren {
  EstimationNewChooseModeIndexLazyRoute: typeof EstimationNewChooseModeIndexLazyRoute
}

const EstimationNewChooseModeLazyRouteChildren: EstimationNewChooseModeLazyRouteChildren =
  {
    EstimationNewChooseModeIndexLazyRoute:
      EstimationNewChooseModeIndexLazyRoute,
  }

const EstimationNewChooseModeLazyRouteWithChildren =
  EstimationNewChooseModeLazyRoute._addFileChildren(
    EstimationNewChooseModeLazyRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AdministrationIndexRoute: AdministrationIndexRoute,
  AiAdvisoryIndexRoute: AiAdvisoryIndexRoute,
  EstimationIndexRoute: EstimationIndexRoute,
  EstimationsIndexLazyRoute: EstimationsIndexLazyRoute,
  NotificationsIndexLazyRoute: NotificationsIndexLazyRoute,
  EstimationEstimationIdContinueWizardLazyRoute:
    EstimationEstimationIdContinueWizardLazyRoute,
  EstimationNewChooseModeLazyRoute:
    EstimationNewChooseModeLazyRouteWithChildren,
  EstimationNewProjectPhasesLazyRoute: EstimationNewProjectPhasesLazyRoute,
  EstimationNewReviewLazyRoute: EstimationNewReviewLazyRoute,
  AdministrationAiWizardIndexRoute: AdministrationAiWizardIndexRoute,
  AdministrationExportSettingsIndexRoute:
    AdministrationExportSettingsIndexRoute,
  EstimationVersionsProjectIdIndexRoute: EstimationVersionsProjectIdIndexRoute,
  EstimationNewIndexRoute: EstimationNewIndexRoute,
  AdministrationEstimationMethodologiesIndexLazyRoute:
    AdministrationEstimationMethodologiesIndexLazyRoute,
  AdministrationEstimationModelsIndexLazyRoute:
    AdministrationEstimationModelsIndexLazyRoute,
  AdministrationIndividualisationIndexLazyRoute:
    AdministrationIndividualisationIndexLazyRoute,
  AdministrationNotificationSettingsIndexLazyRoute:
    AdministrationNotificationSettingsIndexLazyRoute,
  AdministrationNotificationTemplatesIndexLazyRoute:
    AdministrationNotificationTemplatesIndexLazyRoute,
  AdministrationNotificationsIndexLazyRoute:
    AdministrationNotificationsIndexLazyRoute,
  AdministrationProjectTypesIndexLazyRoute:
    AdministrationProjectTypesIndexLazyRoute,
  AdministrationTenantSettingsIndexLazyRoute:
    AdministrationTenantSettingsIndexLazyRoute,
  AdministrationTipsNewsIndexLazyRoute: AdministrationTipsNewsIndexLazyRoute,
  AdministrationUsageAnalyticsIndexLazyRoute:
    AdministrationUsageAnalyticsIndexLazyRoute,
  AdministrationUsersIndexLazyRoute: AdministrationUsersIndexLazyRoute,
  AdministrationWorkflowIndexLazyRoute: AdministrationWorkflowIndexLazyRoute,
  EstimationDetailEstimationIdTabIdRoute:
    EstimationDetailEstimationIdTabIdRoute,
  EstimationNewCostsSummaryLazyRoute: EstimationNewCostsSummaryLazyRoute,
  EstimationNewEstimatingSummaryLazyRoute:
    EstimationNewEstimatingSummaryLazyRoute,
  EstimationNewFromAdvisoryConversationIdLazyRoute:
    EstimationNewFromAdvisoryConversationIdLazyRoute,
  EstimationNewMetadataMandatoryLazyRoute:
    EstimationNewMetadataMandatoryLazyRoute,
  EstimationNewMetadataOptionalLazyRoute:
    EstimationNewMetadataOptionalLazyRoute,
  EstimationNewResourcesSummaryLazyRoute:
    EstimationNewResourcesSummaryLazyRoute,
  AdministrationAiWizardTenantContextIndexRoute:
    AdministrationAiWizardTenantContextIndexRoute,
  EstimationDetailEstimationIdIndexRoute:
    EstimationDetailEstimationIdIndexRoute,
  EstimationNewBasicsIndexRoute: EstimationNewBasicsIndexRoute,
  EstimationNewMetadataIndexRoute: EstimationNewMetadataIndexRoute,
  AdministrationEstimationModelsIdIndexLazyRoute:
    AdministrationEstimationModelsIdIndexLazyRoute,
  EstimationNewCostsIndexLazyRoute: EstimationNewCostsIndexLazyRoute,
  EstimationNewEstimatingIndexLazyRoute: EstimationNewEstimatingIndexLazyRoute,
  EstimationNewResourcesIndexLazyRoute: EstimationNewResourcesIndexLazyRoute,
  EstimationNewEstimatingPhasePhaseIdLazyRoute:
    EstimationNewEstimatingPhasePhaseIdLazyRoute,
  EstimationNewResourcesPhasePhaseIdLazyRoute:
    EstimationNewResourcesPhasePhaseIdLazyRoute,
  EstimationNewBasicsMethodologyIndexLazyRoute:
    EstimationNewBasicsMethodologyIndexLazyRoute,
  EstimationNewBasicsProjectTypeIndexLazyRoute:
    EstimationNewBasicsProjectTypeIndexLazyRoute,
  EstimationNewBasicsProjectIndexLazyRoute:
    EstimationNewBasicsProjectIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
